export default "__VITE_ASSET__af978ffc__"